import {createSelector} from 'reselect';

import {AppState} from '../../appState';
import {getFlatActiveTeammates} from '../teammates/teammatesSelectors';
import {getFlatTeams} from '../teams/teamsSelectors';

export function getUserMetadata(state: AppState) {
  return state.data.userMetadata;
}

function getMentorTeammateId(state: AppState) {
  return state.data.userMetadata.mentorId;
}

/** Find the user's mentor admin - the teammate that invited the user to Front. */
export const getMentorAdminTeammate = createSelector(
  [getMentorTeammateId, getFlatActiveTeammates, getFlatTeams],
  (mentorTeammateId, flatActiveTeammates, teams) => {
    // If we don't have an id for the mentor teammate, skip.
    if (!mentorTeammateId) {
      return undefined;
    }

    // Find the mentor teammate.
    const mentorTeammate = flatActiveTeammates.find((t) => t.id === mentorTeammateId);

    // If the mentor teammate no longer exists or is not active, skip.
    if (!mentorTeammate) {
      return undefined;
    }

    // Check if the mentor is an admin of at least one team.
    const isMentorAnAdmin = teams.find((t) => mentorTeammate.access[t.namespace]?.roles.includes('admin'));

    if (!isMentorAnAdmin) {
      return undefined;
    }

    return mentorTeammate;
  },
);
